



































import { Component, Vue } from 'vue-property-decorator';
import { ApiClient, apiClient } from '@/api/ApiClient';
import moment from 'moment';
import OptionalValue from '@/components/OptionalValue.vue';
import camelcase from 'camelcase';
import { dateRangeTodayUntilEnd } from '@/utils/helper';

@Component({
  components: {
    OptionalValue,
  },
})
export default class extends Vue {

  public get moment() {
    return moment;
  }

  public get JSON() {
    return JSON;
  }

  // table filter
  public range: Date[] = dateRangeTodayUntilEnd();
  public entity: string = null;
  public action: string = null;
  public orderByColumn: string = null;
  public orderByOrder: string = null;

  // table
  public isTableLoading = false;

  public pageSize = 100;
  public total = 0;
  public currentPage = 1;

  public data: any[] = [];
  public actions: any[] = [];
  public entities: any[] = [];

  public mounted() {
    this.loadData();
  }

  // table events
  public async onPaginationChange() {
    await this.loadActionHistories();
    this.$scrollTo("#data-table");
  }

  // sort
  public async tableSortChange({ column, prop, order }) {
    if (prop && order) {
      this.orderByColumn = camelcase(prop.replace('.', '_'));
      this.orderByOrder = order.startsWith("asc") ? "ASC" : 'DESC';
    } else {
      this.orderByOrder = this.orderByColumn = null;
    }
    return this.loadActionHistories();
  }

  //
  private async loadData() {
    await Promise.all([
      this.loadActionHistories(),
      this.loadEntities(),
      this.loadActions(),
    ]);
  }

  private async loadActionHistories() {
    this.isTableLoading = true;
    const range = this.range || [];

    const { data } = await apiClient.actionHistories({
      take: this.pageSize,
      page: this.currentPage,

      orderByColumn: this.orderByColumn,
      orderByOrder: this.orderByOrder,

      from: range[0],
      to: range[1],

      entity: this.entity,
      action: this.action,
    });

    this.total = data.count;
    this.data = data.data;
    this.isTableLoading = false;
  }

  private async loadEntities() {
    const { data } = await apiClient.actionHistoriesEntities();
    this.entities = data;
  }

  private async loadActions() {
    const { data } = await apiClient.actionHistoriesActions();
    this.actions = data;
  }

}
